//WE.Flow.Html.Contracts.Manifests.CustomGroupMenuManifest
import { CustomGroupMenuFunctionType } from "./CustomGroupMenuFunctionType";

export class CustomGroupMenuManifest {
    functionType: CustomGroupMenuFunctionType = null;
    area: string = "";
    name: string = "";
}
